<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-10">
            <div class="titulo">Configuração</div>
            <div class="subTitulo"> Faça aqui sua configurações. </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="borda"></div>
        </div>
      </div>
      <form action="">
        <b-form-group
          id="fieldset-1"
          label="Local de Aplicação"
          label-for="input-1"
        >
          <b-form-input
            id="input-1"
            v-model="configuracao.frase_local_entrega"
            placeholder="Local de Aplicação"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          label="Unidade de Recebimento das Embalagens"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="configuracao.frase_unidade_recebimento"
            placeholder="Unidade de Recebimento das Embalagens"
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          label="Qtde. Mínima Receitas Alerta"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="configuracao.qtde_receita_alerta_art"
            placeholder="Qtde. Mínima Receitas Alerta"
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          label="E-mail alerta ART"
          label-for="input-2"
        >
          <b-form-input
            id="input-2"
            v-model="configuracao.email_alerta_art"
            placeholder="E-mail alerta ART"
          >
          </b-form-input>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="Responsável Técnico"
          label-for="input-3"
        >
          <v-select
            class="style-select"
            label="nome"
            :options="agronomos"
            :reduce="(item) => item.id_agronomo"
            v-model="configuracao.responsavel_tecnico"
            :dense="true"
            @input="$forceUpdate()"
          ></v-select>
        </b-form-group>

        <b-form-group
          id="fieldset-1"
          description=""
          label="Configurações adicionais"
          label-for="input-3"
        >
          <b-form-checkbox v-model="configuracao.gera_receita_xml" switch
            >Receituário XML</b-form-checkbox
          >
          <b-form-checkbox
            v-model="configuracao.baixa_estoque_receituario"
            switch
            >Receituário Baixa Estoque</b-form-checkbox
          >
          <b-form-checkbox
            v-model="configuracao.gera_receita_por_cultura"
            switch
            >Receituário por Cultura</b-form-checkbox
          >
        </b-form-group>
      </form>

      <div>
        <b-button variant="primary" @click="saveOrUpdate">Salvar</b-button>
      </div>

      <div class="borda"></div>

      <section class="defesas-section">
        <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
          <div>
            <h5 class="mb-1">Órgãos de Defesa</h5>
            <p class="text-muted mb-0">Gerencie usuários e tokens de integração por órgão.</p>
          </div>
          <b-button variant="primary" class="mt-2 mt-md-0" @click="abrirModalDefesa">
            Adicionar registro
          </b-button>
        </div>

        <div class="defesas-filtros">
          <div class="row">
            <div class="col-md-4">
              <b-form-group label="Órgão de defesa">
                <b-form-select
                  v-model="filtrosDefesa.nome_orgao_defesa"
                  :options="defesaOrgaoFilterOptions"
                  @change="listarDefesas"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-2">
              <b-form-group label="Ativo">
                <b-form-select
                  v-model="filtrosDefesa.ativo"
                  :options="ativoOptions"
                  @change="listarDefesas"
                ></b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-2 d-flex align-items-end">
              <b-button variant="outline-primary" class="mr-2 mb-3" @click="listarDefesas">
                Filtrar
              </b-button>
              <b-button variant="outline-secondary" class="mb-3" @click="limparFiltrosDefesa">
                Limpar
              </b-button>
            </div>
          </div>
        </div>

        <b-table
          striped
          hover
          responsive
          bordered
          outlined
          small
          :items="defesas"
          :fields="defesaFields"
          :busy="isLoadingDefesas"
        >
          <template v-slot:cell(usuario)="row">
            {{ row.item.usuario || '-' }}
          </template>
          <template v-slot:cell(data_hora_token)="row">
            {{ formatDateTime(row.item.data_hora_token) }}
          </template>
          <template v-slot:cell(ativo)="row">
            <b-badge :variant="row.item.ativo ? 'success' : 'secondary'">
              {{ row.item.ativo ? 'Ativo' : 'Inativo' }}
            </b-badge>
          </template>
          <template v-slot:cell(actions)="row">
            <b-button size="sm" variant="outline-primary" class="mr-2" @click="editarDefesa(row.item)">
              Editar
            </b-button>
            <b-button
              v-if="row.item.ativo"
              size="sm"
              variant="outline-danger"
              @click="inativarDefesa(row.item)"
            >
              Inativar
            </b-button>
          </template>
          <template v-slot:table-busy>
            <div class="text-center text-muted my-3">
              Carregando órgãos de defesa...
            </div>
          </template>
        </b-table>
      </section>
    </div>

    <b-modal
      v-model="showModalDefesa"
      :title="defesaForm.id_defesa ? 'Editar órgão de defesa' : 'Adicionar órgão de defesa'"
      title-class="font-18"
      size="lg"
      @hidden="resetDefesaForm"
    >
      <b-form autocomplete="off">
        <b-form-group label="Nome do órgão de defesa">
          <b-form-select
            v-model="defesaForm.nome_orgao_defesa"
            :options="defesaOrgaoOptions"
          ></b-form-select>
        </b-form-group>

        <b-form-group label="Usuário">
          <b-form-input
            v-model="defesaForm.usuario"
            autocomplete="off"
            name="defesa_usuario_integracao"
            placeholder="CNPJ, login ou usuário do órgão"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Token">
          <b-input-group>
            <b-form-input
              v-model="defesaForm.token"
              :type="showTokenDefesa ? 'text' : 'password'"
              autocomplete="new-password"
              name="defesa_token_integracao"
              placeholder="Senha ou token de autenticação"
            ></b-form-input>
            <b-input-group-append>
              <b-button variant="outline-secondary" @click="showTokenDefesa = !showTokenDefesa">
                {{ showTokenDefesa ? 'Ocultar' : 'Mostrar' }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-group label="Data/hora do token">
          <b-form-input
            v-model="defesaForm.data_hora_token"
            type="datetime-local"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Situação">
          <b-form-checkbox v-model="defesaForm.ativo" switch>
            Ativo
          </b-form-checkbox>
        </b-form-group>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModalDefesa = false">Cancelar</b-button>
        <b-button variant="primary" @click="salvarDefesa">
          {{ defesaForm.id_defesa ? 'Atualizar' : 'Criar' }}
        </b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>

<script>
import serviceAgronomo from '@/src/services/agronomo'
import serviceConfig from '@/src/services/api-receituario/configuracao'
import serviceDefesa from '@/src/services/api-receituario/defesa'
import empresaService from '@/src/services/empresa_sistema'
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  components: { Layout, Loading },
  data() {
    return {
      isLoading: false,
      formato: '',
      agronomos: [],
      empresas: [],
      configuracao: {},
      defesas: [],
      isLoadingDefesas: false,
      showModalDefesa: false,
      showTokenDefesa: false,
      filtrosDefesa: {
        id_empresa_sistema: null,
        nome_orgao_defesa: '',
        ativo: null,
      },
      ativoOptions: [
        { value: null, text: 'Todos' },
        { value: true, text: 'Ativos' },
        { value: false, text: 'Inativos' },
      ],
      defesaOrgaoOptions: [
        { value: '', text: 'Selecione' },
        { value: 'AGRODEFESA', text: 'AGRODEFESA' },
        { value: 'SISDEV', text: 'SISDEV' },
        { value: 'SIGEN', text: 'SIGEN' },
      ],
      defesaFields: [
        { key: 'nome_orgao_defesa', label: 'Órgão' },
        { key: 'usuario', label: 'Usuário' },
        { key: 'data_hora_token', label: 'Data/hora do token' },
        { key: 'ativo', label: 'Ativo' },
        { key: 'actions', label: '' },
      ],
      defesaForm: {
        id_defesa: null,
        id_empresa_sistema: null,
        nome_orgao_defesa: '',
        usuario: '',
        token: '',
        data_hora_token: '',
        ativo: true,
      },
    }
  },
  async mounted() {
    this.findConfig()
    this.findAgronomo()
    this.listarEmpresas()
  },

  computed: {
    defesaOrgaoFilterOptions() {
      return [
        { value: '', text: 'Todos' },
        ...this.defesaOrgaoOptions.filter((option) => option.value),
      ]
    },
  },

  methods: {
    getToken() {
      return this.$store.state.auth.currentUser.token
    },
    getKey() {
      if (this.configuracao && this.configuracao.key) {
        return this.configuracao.key
      }

      try {
        const configLocal = JSON.parse(window.localStorage.getItem('configuracao')) || {}
        return configLocal.key || ''
      } catch (error) {
        return ''
      }
    },
    getCurrentEmpresaId() {
      const user = this.$store && this.$store.state.auth
        ? this.$store.state.auth.currentUser
        : null

      const candidates = [
        user && user.id_empresa_sistema,
        user && user.id_empresa,
        user && user.idEmpresa,
        user && user.empresa_id,
        user && user.idEmpresaSistema,
        user && user.empresa && user.empresa.id_empresa_sistema,
        user && user.empresa && user.empresa.id_empresa,
        user && user.empresa && user.empresa.id,
      ]

      for (let i = 0; i < candidates.length; i += 1) {
        const parsed = Number(candidates[i])
        if (!Number.isNaN(parsed) && parsed > 0) {
          return parsed
        }
      }

      if (this.empresas.length === 1) {
        const parsed = Number(this.empresas[0].id_empresa_sistema)
        return !Number.isNaN(parsed) && parsed > 0 ? parsed : null
      }

      return null
    },
    getErrorMessage(error, fallback) {
      return error &&
        error.response &&
        error.response.data &&
        error.response.data.message
        ? error.response.data.message
        : fallback
    },
    findConfig() {
      this.isLoading = true
      const token = this.getToken()
      serviceConfig
        .listar(token)
        .then((resposta) => {
          this.configuracao = resposta.data.configuracoes[0]
          console.log(this.configuracao)
          this.isLoading = false
          this.listarDefesas()
        })
        .catch((error) => {
          this.isLoading = false
        })
    },

    findAgronomo() {
      this.isLoading = true
      const token = this.getToken()
      serviceAgronomo
        .listar(token)
        .then((resposta) => {
          this.agronomos = resposta.data.data
          this.isLoading = false
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    listarEmpresas() {
      const token = this.getToken()

      empresaService
        .listarEmpresa(token)
        .then((resposta) => {
          const empresas = resposta.data.empresa || resposta.data.data || []
          this.empresas = empresas.map((empresa) => ({
            ...empresa,
            nome:
              empresa.nome ||
              empresa.nome_fantasia ||
              empresa.razao_social ||
              empresa.razaoSocial ||
              `Empresa ${empresa.id_empresa_sistema}`,
          }))

          if (!this.defesaForm.id_empresa_sistema) {
            this.defesaForm.id_empresa_sistema = this.getCurrentEmpresaId()
          }
        })
        .catch(() => {
          this.empresas = []
        })
    },
    buildDefesaFilters() {
      const filters = {}
      const idEmpresa = this.getCurrentEmpresaId()

      if (idEmpresa) {
        filters.id_empresa_sistema = idEmpresa
      }

      if (this.filtrosDefesa.nome_orgao_defesa) {
        filters.nome_orgao_defesa = this.filtrosDefesa.nome_orgao_defesa
      }

      if (this.filtrosDefesa.ativo !== null && this.filtrosDefesa.ativo !== undefined) {
        filters.ativo = this.filtrosDefesa.ativo
      }

      return filters
    },
    normalizeDefesasResponse(resposta) {
      const payload = resposta && resposta.data ? resposta.data : {}

      if (Array.isArray(payload)) {
        return payload
      }

      if (Array.isArray(payload.data)) {
        return payload.data
      }

      if (Array.isArray(payload.defesas)) {
        return payload.defesas
      }

      return []
    },
    listarDefesas() {
      const token = this.getToken()
      const key = this.getKey()

      this.isLoadingDefesas = true

      serviceDefesa
        .listar(token, key, this.buildDefesaFilters())
        .then((resposta) => {
          this.defesas = this.normalizeDefesasResponse(resposta)
        })
        .catch((error) => {
          this.$bvToast.toast(
            this.getErrorMessage(error, 'Não foi possível listar os órgãos de defesa.'),
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.defesas = []
        })
        .finally(() => {
          this.isLoadingDefesas = false
        })
    },
    limparFiltrosDefesa() {
      this.filtrosDefesa = {
        id_empresa_sistema: null,
        nome_orgao_defesa: '',
        ativo: null,
      }
      this.listarDefesas()
    },
    resetDefesaForm() {
      this.showTokenDefesa = false
      this.defesaForm = {
        id_defesa: null,
        id_empresa_sistema: this.getCurrentEmpresaId(),
        nome_orgao_defesa: '',
        usuario: '',
        token: '',
        data_hora_token: '',
        ativo: true,
      }
    },
    abrirModalDefesa() {
      this.resetDefesaForm()
      this.showModalDefesa = true
    },
    toDatetimeLocal(value) {
      if (!value) {
        return ''
      }

      const date = new Date(value)

      if (Number.isNaN(date.getTime())) {
        return ''
      }

      const offset = date.getTimezoneOffset()
      const localDate = new Date(date.getTime() - offset * 60000)
      return localDate.toISOString().slice(0, 16)
    },
    formatDateTime(value) {
      if (!value) {
        return '-'
      }

      const date = new Date(value)

      if (Number.isNaN(date.getTime())) {
        return value
      }

      return date.toLocaleString('pt-BR')
    },
    getEmpresaLabel(defesa) {
      if (defesa.empresa) {
        return (
          defesa.empresa.nome ||
          defesa.empresa.nome_fantasia ||
          defesa.empresa.razao_social ||
          defesa.empresa.razaoSocial ||
          '-'
        )
      }

      const empresa = this.empresas.find(
        (item) => item.id_empresa_sistema === defesa.id_empresa_sistema
      )

      return empresa ? empresa.nome : defesa.id_empresa_sistema || '-'
    },
    editarDefesa(defesa) {
      const token = this.getToken()
      const key = this.getKey()

      this.isLoadingDefesas = true

      serviceDefesa
        .findById(token, key, defesa.id_defesa)
        .then((resposta) => {
          const item =
            resposta.data.defesa ||
            resposta.data.data ||
            resposta.data

          this.defesaForm = {
            id_defesa: item.id_defesa,
            id_empresa_sistema: item.id_empresa_sistema,
            nome_orgao_defesa: item.nome_orgao_defesa || '',
            usuario: item.usuario || '',
            token: item.token || '',
            data_hora_token: this.toDatetimeLocal(item.data_hora_token),
            ativo: item.ativo !== false,
          }
          this.showModalDefesa = true
        })
        .catch((error) => {
          this.$bvToast.toast(
            this.getErrorMessage(error, 'Não foi possível carregar o órgão de defesa.'),
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
        .finally(() => {
          this.isLoadingDefesas = false
        })
    },
    buildDefesaPayload() {
      const idEmpresa = this.defesaForm.id_empresa_sistema || this.getCurrentEmpresaId()

      return {
        id_defesa: this.defesaForm.id_defesa,
        id_empresa_sistema: idEmpresa ? Number(idEmpresa) : null,
        nome_orgao_defesa: this.defesaForm.nome_orgao_defesa,
        usuario: this.defesaForm.usuario || null,
        token: this.defesaForm.token,
        data_hora_token: this.defesaForm.data_hora_token,
        ativo: Boolean(this.defesaForm.ativo),
      }
    },
    validarDefesaForm() {
      if (!this.defesaForm.id_empresa_sistema && !this.getCurrentEmpresaId()) {
        return 'Não foi possível identificar a empresa logada.'
      }

      if (!this.defesaForm.nome_orgao_defesa) {
        return 'Informe o nome do órgão de defesa.'
      }

      if (!this.defesaForm.token) {
        return 'Informe o token.'
      }

      if (!this.defesaForm.data_hora_token) {
        return 'Informe a data/hora do token.'
      }

      return ''
    },
    salvarDefesa() {
      const validationMessage = this.validarDefesaForm()

      if (validationMessage) {
        this.$bvToast.toast(validationMessage, {
          variant: 'warning',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      const token = this.getToken()
      const key = this.getKey()
      const payload = this.buildDefesaPayload()
      const request = payload.id_defesa
        ? serviceDefesa.update(token, key, payload)
        : serviceDefesa.salvar(token, key, payload)

      this.isLoadingDefesas = true

      request
        .then(() => {
          this.$bvToast.toast(
            payload.id_defesa ? 'Órgão de defesa atualizado!' : 'Órgão de defesa criado!',
            {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
          this.showModalDefesa = false
          this.listarDefesas()
        })
        .catch((error) => {
          this.$bvToast.toast(
            this.getErrorMessage(error, 'Não foi possível salvar o órgão de defesa.'),
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
        .finally(() => {
          this.isLoadingDefesas = false
        })
    },
    inativarDefesa(defesa) {
      this.$bvModal
        .msgBoxConfirm('Deseja inativar este órgão de defesa?', {
          title: 'Inativar órgão de defesa',
          okTitle: 'Inativar',
          cancelTitle: 'Cancelar',
          okVariant: 'danger',
          cancelVariant: 'light',
        })
        .then((confirmado) => {
          if (!confirmado) {
            return
          }

          const token = this.getToken()
          const key = this.getKey()
          this.isLoadingDefesas = true

          serviceDefesa
            .deletar(token, key, defesa.id_defesa)
            .then(() => {
              this.$bvToast.toast('Órgão de defesa inativado!', {
                variant: 'success',
                solid: false,
                noCloseButton: true,
                toaster: 'b-toaster-top-center',
              })
              this.listarDefesas()
            })
            .catch((error) => {
              this.$bvToast.toast(
                this.getErrorMessage(error, 'Não foi possível inativar o órgão de defesa.'),
                {
                  variant: 'danger',
                  solid: false,
                  noCloseButton: true,
                  toaster: 'b-toaster-top-center',
                }
              )
            })
            .finally(() => {
              this.isLoadingDefesas = false
            })
        })
    },

    saveOrUpdate() {
      this.isLoading = true
      const token = this.getToken()

      if (this.configuracao.id) {
        serviceConfig
          .update(token, this.configuracao)
          .then((resposta) => {
            this.isLoading = false
            this.$bvToast.toast('Configuração atualizada!', {
              variant: 'success',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            window.localStorage.setItem(
              'configuracao',
              JSON.stringify(this.configuracao)
            )
          })
          .catch((erro) => {
            this.isLoading = false
            this.$bvToast.toast(erro.response.data.message, {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
          })
        return
      }
      serviceConfig
        .salvar(token, this.configuracao)
        .then((resposta) => {
          this.isLoading = false
          this.$bvToast.toast('Configuração salva!', {
            variant: 'success',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
          window.localStorage.setItem(
            'configuracao',
            JSON.stringify(this.configuracao)
          )
        })
        .catch((erro) => {
          this.isLoading = false
          this.$bvToast.toast(erro.response.data.message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
    },
  },
}
</script>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
